// Client V2 common imports
const { NextPageStateEnum } = require('client-v2/common/utils/enums')
// Sibling imports
const actions = require('./actions')
const CollectionEditCoverImageModalRecord = require('./record')

// eslint-disable-next-line complexity
function collectionEditCoverImageModalReducer(
  state = new CollectionEditCoverImageModalRecord(),
  { type, payload }
) {
  if (type === actions.SHOW) {
    return new CollectionEditCoverImageModalRecord()
  }
  // All other actions should only matter after SHOW
  if (!state) {
    return state
  }
  switch (type) {
    case actions.HIDE:
      return null
    case actions.FETCH_PENDING:
      return state.merge({
        nextPageState: NextPageStateEnum.LOADING
      })
    case actions.FETCH_FAILED:
      return state.merge({
        nextPageState: NextPageStateEnum.UNAVAILABLE
      })
    case actions.FETCH_SUCCESS:
      return state.merge({
        images: (
          payload.isFirstPage
          ? payload.items
          : state.images.concat(payload.items)
        ),
        nextPageNumber: payload.nextPage,
        nextPageState: payload.state
      })
    default:
      return state
  }
}

module.exports = collectionEditCoverImageModalReducer
